import React, { useState, useRef, useEffect } from "react";
import "./index.css"; // 自定义样式

const FloatingWindow = (props) => {
  const { docs, onClose } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [position, setPosition] = useState({
    x: window.innerWidth - 400,
    y: 100,
  });
  const [size, setSize] = useState({ width: 350, height: 500 });
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });

  const windowRef = useRef(null);
  const headerRef = useRef(null);

  // 处理鼠标按下（拖拽开始）
  const handleMouseDown = (e) => {
    if (e.button !== 0) return; // 只响应左键
    setIsDragging(true);
    setStartPos({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
    e.preventDefault();
  };

  // 处理右键按下（调整大小开始）
  const handleRightMouseDown = (e) => {
    if (e.button !== 2) return; // 只响应右键
    setIsResizing(true);
    setStartPos({
      x: e.clientX,
      y: e.clientY,
    });
    e.preventDefault();
  };

  // 处理鼠标移动
  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - startPos.x,
        y: e.clientY - startPos.y,
      });
    } else if (isResizing) {
      const newWidth = size.width + (e.clientX - startPos.x);
      const newHeight = size.height + (e.clientY - startPos.y);

      // 保持A4比例 (约1.414)
      //const a4Ratio = Math.sqrt(2);
      //const adjustedHeight = newWidth * a4Ratio;

      setSize({
        width: Math.max(300, newWidth), // 最小宽度300px
        height: Math.max(300, newHeight), // 最小高度300px
      });

      setStartPos({
        x: e.clientX,
        y: e.clientY,
      });
    }
  };

  // 处理鼠标释放
  const handleMouseUp = () => {
    setIsDragging(false);
    setIsResizing(false);
  };

  // 添加全局鼠标事件监听
  useEffect(() => {
    if (isDragging || isResizing) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    }
  }, [isDragging, isResizing, handleMouseMove, handleMouseUp]);

  // 计算MP4视频显示尺寸
  const getVideoSize = () => {
    const videoWidth = size.width - 40; // 减去padding
    return {
      width: videoWidth,
      height: (videoWidth * 9) / 16, // 16:9比例
    };
  };

  return (
    <div
      ref={windowRef}
      className="floating-window"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: `${size.width}px`,
        height: `${size.height}px`,
      }}
      onMouseDown={handleMouseDown}
      onContextMenu={(e) => e.preventDefault()}
    >
      {/* 标题栏 - 包含标题和关闭按钮 */}
      <div
        ref={headerRef}
        className="window-header"
        onMouseDown={handleMouseDown}
      >
        <h3 className="window-title">培训文档</h3>
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
      </div>
      {/* 标签页 */}
      <div className="tabs-container">
        {docs.map((doc, index) => (
          <div
            key={doc.id}
            className={`tab ${activeTab === index ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {index + 1}
          </div>
        ))}
      </div>

      {/* 调整大小手柄 */}
      <div className="resize-handle" onMouseDown={handleRightMouseDown} />

      <div className="window-content">
        {docs[activeTab].type.indexOf("video") !== -1 ? (
          <div className="video-container">
            <video
              className="mock-video"
              style={getVideoSize()}
              controls
              controlsList="nodownload"
            >
              <source src={docs[activeTab]?.url} type="video/mp4" />
            </video>
          </div>
        ) : docs[activeTab].type.indexOf("audio") !== -1 ? (
          <audio
            controls
            autoPlay={false}
            src={docs[activeTab]?.url}
            style={{
              position: "absolute",
              top: "50%",
              left: "calc(50% - 150px)",
            }}
          ></audio>
        ) : docs[activeTab].type.indexOf("image") !== -1 ? (
          <img
            src={docs[activeTab]?.url}
            style={{ width: "100%", height: "100%" }}
          ></img>
        ) : docs[activeTab].type.indexOf("sheet") !== -1 ? (
          <iframe
            title="txtPreview"
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              docs[activeTab]?.url
            )}#page=${1}&toolbar=0`}
            style={{ width: "100%", height: "100%" }}
          ></iframe>
        ) : (
          <div className="pdf-preview">
            <iframe
              title="txtPreview"
              src={`${docs[activeTab]?.url}#page=${1}&toolbar=0`}
              style={{ width: "100%", height: "100%" }}
            ></iframe>
          </div>
        )}
      </div>
    </div>
  );
};

export default FloatingWindow;
